import { Controller } from "stimulus"

export default class extends Controller {
  static values = { interval: Number }

  connect() {
    this.baseSrc = this.element.getAttribute("src")
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
    clearTimeout(this.timer)
  }

  onFrameLoad = () => {
    const hasPollStop = !!this.element.querySelector("[data-poll-stop]")
    clearTimeout(this.timer)
    if (!hasPollStop) {
      this.timer = setTimeout(() => {
        this.refresh()
      }, this.intervalValue || 2000)
    }
  }

  refresh() {
    const url = new URL(this.baseSrc, location)
    url.searchParams.set("t", Date.now())
    const newSrc = url.toString()
    this.element.setAttribute("src", newSrc)
  }
}
